<template>
  <div class="chart-type-switcher">
    <span
      class="option"
      :class="{'option_selected': !chartTypeIsMarketcap}"
    >Price</span>
    <switcher-el
      class="switcher"
      id="chartType"
      v-model="chartTypeIsMarketcap"
    />
    <span
      class="option"
      :class="{'option_selected': chartTypeIsMarketcap}"
    >Market Cap</span>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean, // true if chartTypeIsMarketcap
  },
  computed: {
    chartTypeIsMarketcap: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>


<style lang="scss" scoped>
.chart-type-switcher {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 167px;
}
.switcher {
  display: flex;
}
.option {
  @include font(13px, $black-color1, 500);
  &_selected {
    color: $red-color3;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/currency/chartBlock/ChartTypeSwitcher.vue